import { render, staticRenderFns } from "./BorcluDetayUyapInfoList.vue?vue&type=template&id=a1478928"
import script from "./BorcluDetayUyapInfoList.vue?vue&type=script&lang=ts"
export * from "./BorcluDetayUyapInfoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports